jQuery( document ).ready( function ( $ ) {

  /******************************************************************************
   *****   Standard Modals used across the site                         ********
   ******************************************************************************/

  $( ".modal-open" ).click( function ( event ) {
    if ( $( "body" ).hasClass( "modal-active" ) ) {
      // nothing
    } else {
      var $id = $( this ).data( 'id' ),
        $modals = $( '.modal .container .inner' ).children();

      $modals.each( function ( index, el ) {
        $modalId = $( el ).data( 'id' );
        if ( $modalId == $id ) {

          var $iframe = $( el ).children( 'iframe' );
          if ( $iframe.hasClass( 'youtube' ) ) {
            var video = $( $iframe ).attr( "src" );

            if ( video.includes( 'youtube' ) ) {
              setTimeout( function () {
                video = video.replace( "?autoplay=0", "?autoplay=1" );
                $( $iframe ).attr( "src", video );
              }, 800 );
            }
          }

          $( el ).addClass( 'active' );

        }
      } );

      $( "body" ).addClass( "modal-active" );​
    }
  } );​

  $( ".close-modal" ).click( function ( event ) {
    if ( $( "body" ).hasClass( "modal-active" ) ) {

      var $iframe = $( '.modal .content.active' ).children( 'iframe' );

      if ( $iframe.hasClass( 'youtube' ) ) {
        var video = $( $iframe ).attr( "src" );

        if ( video.includes( 'youtube' ) ) {
          video = video.replace( "?autoplay=1", "?autoplay=0" );
          $( $iframe ).attr( "src", "" );
          $( $iframe ).attr( "src", video );
        }
      }

      $( "body" ).removeClass( "modal-active" );
      $( '.modal .container .inner' ).children().removeClass( 'active' );

    } else {
      //nothing
    }
  } );​
  /******************************************************************************
   *****   END Standard Modals used across the site                         ********
   ******************************************************************************/

  /******************************************************************************
   *****   Before you go Modal on Buying / Selling pages                ********
   ******************************************************************************/

  if ( $( "#wait-modal" ).length ) {
    /* Press close button, close modal */
    $( "#close-wait" ).click( function ( e ) {
      setCookie( "waitClose", "closed", 1 );
      closeModal();
    } );

    /* Click overlay part of modal, close modal */
    $( "#wait-modal" ).click( function ( e ) {
      if ( e.target != this ) return;
      setCookie( "waitClose", "closed", 1 );
      closeModal();
    } );

    /* Press esc key, close modal */
    $( document ).keyup( function ( e ) {
      if ( e.keyCode == 27 && $( "#wait-modal" ).hasClass( "is-active" ) ) {
        setCookie( "waitClose", "closed", 1 );
        closeModal();
      }
    } );

    /* Open modal function */
    function openModal( contentId ) {
      $( "#wait-modal" ).addClass( "is-active" );
      $( "body" ).addClass( "noscroll" );
    }

    /* Close modal function */
    function closeModal() {
      $( "#wait-modal" ).removeClass( "is-active" );
      $( "body" ).removeClass( "noscroll" );
    }

    if ( getCookie( "waitSubmit" ) != "submitted" ) {
      if ( getCookie( "waitClose" ) != "closed" ) {
        $( window ).mousemove( function ( e ) {
          if ( getCookie( "waitSubmit" ) == "submitted" ) {
            return false;
          } else if ( getCookie( "waitClose" ) == "closed" ) {
            return false;
          } else if ( e.clientY < 5 ) {
            openModal( "#wait-modal" );
          }
        } );
      }
    }
  }

  $( "#gform_submit_button_9" ).click( function ( event ) {
    setCookie( "waitSubmit", "submitted", 120 );
  } );

  function getCookie( cname ) {
    var name = cname + "=";
    var ca = document.cookie.split( ";" );
    for ( var i = 0; i < ca.length; i++ ) {
      var c = ca[ i ];
      while ( c.charAt( 0 ) == " " ) {
        c = c.substring( 1 );
      }
      if ( c.indexOf( name ) == 0 ) {
        return c.substring( name.length, c.length );
      }
    }
    return "";
  }

  function setCookie( cname, cvalue, exdays ) {
    var d = new Date();
    d.setTime( d.getTime() + exdays * 24 * 60 * 60 * 1000 );
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  /******************************************************************************
   ***************   END OF before you go Modal code                *************
   ******************************************************************************/

} );